export const formatToWeekDay = (date: string | Date) => {
  const str = new Intl.DateTimeFormat("pt-BR", {
    weekday: "long",
    timeZone: "America/Recife",
  }).format(new Date(date));
  return (str.charAt(0).toLocaleUpperCase() + str.slice(1)).replace(/-Feira/i, "");
};
